import React from "react";
import LegalPage, { Section, H2, P } from "./components/LegalPage";
import { ANBIETER } from "./anbieter";

export default function Impressum() {
  return (
    <LegalPage title="Impressum">
      <Section>
        <H2>Angaben gemäß § 5 DDG</H2>
        <P style={{ margin: 0 }}>
          {ANBIETER.geschaeftsbezeichnung}
          <br />
          Inhaber: {ANBIETER.inhaber}
          <br />
          {ANBIETER.strasse}
          <br />
          {ANBIETER.ort}
          <br />
          {ANBIETER.land}
        </P>
      </Section>

      <Section>
        <H2>Kontakt</H2>
        <P style={{ margin: 0 }}>
          E-Mail:{" "}
          <a href={`mailto:${ANBIETER.email}`} className="sb-link">
            {ANBIETER.email}
          </a>
        </P>
      </Section>

      <Section>
        <H2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H2>
        <P style={{ margin: 0 }}>
          {ANBIETER.inhaber}, Anschrift wie oben
        </P>
      </Section>

      <Section>
        <H2>Verbraucherstreitbeilegung</H2>
        <P style={{ margin: 0 }}>
          Wir sind nicht bereit und nicht verpflichtet, an
          Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          teilzunehmen.
        </P>
      </Section>
    </LegalPage>
  );
}
